<template>
<v-toolbar class="white elevation-0 mb-2">
  <v-toolbar-title style="padding-top:50px;">
    <span class="logo" v-if="disable">
      <img style="margin-bottom: -6px !important;" src="../../img/logo.png" height="31"/>
      <span style="font-weight:600;color:#4db6ac;">Probe Miner</span>
      <div style="font-size:13px;padding:0 0 0 11px;">Chemical Probes Objective Assessment Resource</div>
    </span>
    <router-link :to="{ path: '/' }" v-if="!disable">
      <span class="logo">
        <img style="margin-bottom: -6px !important;" src="../../img/logo.png" height="31"/>
        <span style="font-weight:600;color:#4db6ac;">Probe Miner</span>
        <div style="font-size:13px;padding:0 0 0 11px;">Chemical Probes Objective Assessment Resource</div>
      </span>
    </router-link>
  </v-toolbar-title>
  <v-spacer></v-spacer>
  <div v-if="disable">
    <v-btn flat disabled>Home</v-btn>
    <v-btn flat disabled>About</v-btn>
    <v-btn flat disabled>Tutorial</v-btn>
    <v-btn flat disabled>Download</v-btn>
    <v-btn flat disabled>Limitations</v-btn>
    <v-btn flat disabled>FAQ</v-btn>
    <v-btn flat disabled>Contact us</v-btn>
  </div>
  <div v-if="!disable" class="menu">
    <router-link :to="{ path: '/' }">
      <v-btn flat><v-icon left style="color:#455A64;padding-bottom:2px;">home</v-icon>home</v-btn>
    </router-link>
    <router-link :to="{ path: '/about' }">
      <v-btn flat>About</v-btn>
    </router-link>
    <router-link :to="{ path: '/tutorial' }">
      <v-btn flat>Tutorial</v-btn>
    </router-link>
    <router-link :to="{ path: '/download' }">
      <v-btn flat>Download</v-btn>
    </router-link>
    <router-link :to="{ path: '/limitations' }">
      <v-btn flat>Limitations</v-btn>
    </router-link>
    <router-link :to="{ path: '/faq' }">
      <v-btn flat>FAQ</v-btn>
    </router-link>
    <router-link :to="{ path: '/contact' }">
      <v-btn flat>Contact</v-btn>
    </router-link>
  </div>
</v-toolbar>
</template>

<script>
export default {
  props: ['disable']
}
</script>

<style scoped>
a {
  text-decoration: none;

}

.logo{
  font-size: 28px;
  font-weight: 300;
  color: #263238;
  top: 10px !important;
  margin-left: 10px;
}

@media screen and (max-width: 1600px) {
  .logo {
    font-size: 22px !important;
  }
  .menu{
    padding: 20px 0 0 0;
  }
}

@media screen and (max-width: 1000px) {
  .logo{
    font-size: 12px !important;
  }
}
</style>



// WEBPACK FOOTER //
// PrbToolbar.vue?73a2c824